"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRICING_TIMEOUT = exports.CdaCommands = void 0;
var CdaCommands;
(function (CdaCommands) {
    CdaCommands["GET_AUTH_STATE"] = "getAuthState";
    CdaCommands["MOP_DETAILS"] = "mopDetails";
    CdaCommands["ORDER_DETAILS_PAUSED_PENDING_CANCEL"] = "withOrderDetailsPausedPendingCancelledState";
    CdaCommands["DETERMINE_NEXT_INTERACTION"] = "determineNextInteraction";
    CdaCommands["GET_MOP_RESUBSCRIBE"] = "getMopSummaryResubscribeState";
    CdaCommands["ORDER_DETAILS_PAUSED_PENDINGPAUSE_PENDINGCANCEL"] = "withOrderDetailsPausedPendingCancelPendingPauseState";
    CdaCommands["MOST_RECENT_MOP"] = "1Click";
    CdaCommands["GET_TAX_INFO"] = "getTaxQuote";
})(CdaCommands = exports.CdaCommands || (exports.CdaCommands = {}));
exports.PRICING_TIMEOUT = 10000;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/pricing-sdk/dist/lib-esm/modules/nextInteractionApi/interfaces.js
// module id = 3412
// module chunks = 11